import { Component } from '@angular/core';

@Component({
    selector: 'app-not-autorization',
    templateUrl: './not-autorization.component.html',
    standalone: true
})
export class NotAutorizationComponent {}
